<template>
  <section
    class="base-list"
    :class="`base-list--${type}`"
  >
    <component
      :is="titleTagName"
      v-if="title"
      class="base-list__title"
    >
      {{ title }}
    </component>

    <div class="base-list__items">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="base-list__item"
        :class="{ ingredient: hrecipeIngredient }"
      >
        <div
          class="base-list__item-name"
          :class="{ name: hrecipeIngredient }"
          v-bind="addItemPropRecipeIngredient ? { itemprop: 'recipeIngredient' } : {}"
        >
          <component
            :is="item.link ? 'BaseLink' : 'span'"
            :href="item.link ? removeHostFromUrl(item.link) : undefined"
            >{{ item.text }}</component
          >

          <p
            v-if="item.description"
            class="base-list__item-description"
          >
            {{ item.description }}
          </p>
        </div>
        <div
          class="base-list__item-count"
          :class="{ amount: hrecipeIngredient }"
        >
          <component
            :is="item.machineAmount ? 'abbr' : 'span'"
            v-if="hrecipeTimeClasses[index]"
            :class="(hrecipeTimeClasses[index] as string)"
            :title="item.machineAmount"
          >{{ item.amount }}</component>
          <span
            v-else-if="hrecipeYield"
            class="yield"
          >{{ item.amount }}</span>
          <template v-else>{{ item.amount }}</template>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { BaseListElem } from '~/types/components/BaseList';
  import BaseLink from '@devhacker/shared/components/base/BaseLink.vue';
  import removeHostFromUrl from '@devhacker/shared/utils/removeHostFromUrl';

  export default defineNuxtComponent({
    name: 'BaseList',

    components: { BaseLink },

    props: {
      items: {
        type: Array as PropType<BaseListElem[]>,
        required: true,
      },
      title: {
        type: String as PropType<string>,
        default: 'Ингредиенты',
      },
      type: {
        type: String as PropType<string>,
        default: '',
      },
      titleTagName: {
        type: String as PropType<string>,
        default: 'p',
      },
      addItemPropRecipeIngredient: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
      hrecipeIngredient: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
      hrecipeYield: {
        type: Boolean as PropType<boolean>,
        default: false,
      },
      hrecipeTimeClasses: {
        type: Array as PropType<string[]>,
        default: () => [],
      },
    },

    methods: { removeHostFromUrl },
  });
</script>

<style lang="scss" scoped>
  @use './mixins' as *;

  .base-list {
    padding: 12px 16px 8px;
    background: white;
    border: 1px solid $borderColor;
    position: relative;
    /* use from ./mixins */
    border-top: 3px solid #ed5e42;

    @include tablet {
      padding: 16px 24px 8px;
    }

    &__title {
      margin-bottom: 6px;

      font-family: $secondFont;
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      @include tablet {
        margin-bottom: 8px;

        font-size: 20px;
        line-height: 28px;
      }
    }

    &__item {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 12px 0;

      &:not(:last-child) {
        border-bottom: 1px solid $borderColor;
      }

      @include print {
        @include padding-y(10px);
      }
    }

    &__item-name {
      flex: 0 0 60%;
      padding-right: 8px;

      font-family: $mainFont;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      @include tablet {
        font-size: 16px;
        line-height: 24px;
      }
      @include print {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        font-family: $secondFont;
      }
    }

    &__item-description {
      @include fontTinyText;

      @include tablet {
        @include fontSmallText;
        color: #5c5c5c;
      }

      @include print {
        @include fontTinyText;
      }
    }

    &__item-count {
      flex: 0 1 40%;
      text-align: right;

      font-family: $mainFont;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      @include tablet {
        font-size: 16px;
        line-height: 24px;
      }
      @include print {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        font-family: $mainFont;
      }

      /* машинное значение duration отдаётся через abbr[title] для hRecipe */
      abbr {
        text-decoration: none;
        cursor: inherit;
      }
    }
  }

  .base-list--portions {
    padding-top: 8px;
    padding-bottom: 8px;
  }
</style>
